import { PaymentMethod } from '@bigcommerce/checkout-sdk'
import request from '../request'

const paymentsRefresh = (methods: PaymentMethod[]) => {

  const newMethod = methods.map((method: PaymentMethod) => {
    return {
      code: method.id,
      name: method?.config?.displayName || method.gateway
    }
  })

  return request.api.paymentsRefresh({payments: newMethod})
}

export {
  paymentsRefresh
}
